import { Controller } from 'react-hook-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../../components/shadcn/select';
import { FilterViewModel } from '../../../../types/domain';

type DropdownFilterProps = {
  filter: FilterViewModel;
  fieldName: string;
  control: any;
};

export const DropdownFilter = ({ filter, fieldName, control }: DropdownFilterProps) => {
  return (
    <Controller
      name={fieldName}
      control={control}
      defaultValue={['']}
      render={({ field }) => (
        <Select
          value={(field.value && field.value[0]) || ''}
          onValueChange={(v: string) => field.onChange([v])}
        >
          <SelectTrigger>
            <SelectValue placeholder={`Select ${filter.name.toLowerCase()}`} />
          </SelectTrigger>
          <SelectContent>
            {filter.values?.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                <span>{option.label}</span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    />
  );
};